<script setup lang="ts">
import { useTemplateRef } from "vue";
import type { IconProps } from "./icon.types";
import { useIcon } from "./useIcon";

const props = defineProps<IconProps>();
const iconEl = useTemplateRef<HTMLElement>("iconEl");
const { classes } = useIcon({ props, iconEl });
</script>

<template>
  <div ref="iconEl" part="base" class="e-icon" :class="classes" />
</template>

<style>
:host {
  display: contents;
}
</style>
